import Api from './Api';
import resolve from  '../util/Configuracao';
class SaudeCaixaApi extends Api {

  async validarArquivo (file) {
    const validarArquivoUrl = resolve('urlValidarArquivoCaixa');
    const result = await this.fetch(validarArquivoUrl, 'post', file);
    return result;
  }

  async enviarArquivo (file) {
    try {
      const enviarArquivoUrl = resolve('urlEnviarArquivoCaixa');
      const result = await this.fetch(enviarArquivoUrl, 'post', file);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarArquivos (codArquivo, indProcessado) {
    let arquivos = [];
    const brancoAcoes = '';
    try {
      const urlConsultarArquivosCaixaNaoPagos = resolve('urlConsultarArquivosCaixaNaoPagos') + codArquivo + '/' + indProcessado;
      const { data } = await this.fetch(urlConsultarArquivosCaixaNaoPagos);
      data.map(res => {
        const { codArquivo, nomeArquivo, txtObjetoGed, qtdRegistros, qtdRegistrosImportados, qtdRegistrosRejeitados, valTotalAutorizado,
          valTotalImportado, valTotalRejeitado, dtaImportacao, codUsuarioImportacao, indCoparticipacaoCobrada} = res;
        arquivos.push(Object.values({ codArquivo, nomeArquivo, txtObjetoGed, qtdRegistros, qtdRegistrosImportados, qtdRegistrosRejeitados, valTotalAutorizado,
          valTotalImportado, valTotalRejeitado, dtaImportacao, codUsuarioImportacao, indCoparticipacaoCobrada, brancoAcoes}));
      });
      return arquivos;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDetalhesArquivo (codArquivo) {
    let detalhes = [];
    try {
      const urlConsultarDetalhesArquivoCaixa = resolve('urlConsultarDetalhesArquivoCaixa') + codArquivo;
      const { data } = await this.fetch(urlConsultarDetalhesArquivoCaixa);
      data.map(res => {
        const { codFaturaSaudeCaixa, txtCarteiraCaixa, carteiraTst, nome, dtaAtendimento, codEvento, desItem, numQtdCobrada, valTotalCobrado, dtaCalcCopart, numCpfCnpj, nomePrestador, valCopartCobrada, percCopart } = res;
          detalhes.push(Object.values({codFaturaSaudeCaixa, txtCarteiraCaixa, carteiraTst, nome, dtaAtendimento, codEvento, desItem, numQtdCobrada, valTotalCobrado, valCopartCobrada, percCopart, dtaCalcCopart, numCpfCnpj, nomePrestador }));
      });
      return detalhes;
    } catch (error) {
      console.error(error);
    }
  }
  async calcularCoparticipacao (codArquivo, procedimentos) {
    try {
      const urlCalcularCoparticipacaoCaixa = resolve('urlCalcularCoparticipacaoCaixa') + codArquivo;
      const response = await this.fetch(urlCalcularCoparticipacaoCaixa, 'post', procedimentos);
      return response;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  async excluirArquivos (arquivos) {
    try {
      const urlExcluirArquivosCaixa = resolve('urlExcluirArquivosCaixa');
      const result = await this.fetch(urlExcluirArquivosCaixa, 'post', arquivos);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }

}
export default SaudeCaixaApi;
